import { render, staticRenderFns } from "./ProductBox1.vue?vue&type=template&id=5fe8c299&scoped=true"
import script from "./ProductBox1.vue?vue&type=script&lang=js"
export * from "./ProductBox1.vue?vue&type=script&lang=js"
import style0 from "./ProductBox1.vue?vue&type=style&index=0&id=5fe8c299&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe8c299",
  null
  
)

export default component.exports